import React, { FC } from "react";
import { Box } from "../../components/box";
import { Header } from "../../components/header";
import { Button } from "../../modules/button";
import { ObjectUtils } from "../../modules/utils";
import { useSelector } from "../../store/store";
import { useMsal } from "@azure/msal-react";
import { handleOneSignalLogout } from "../../actions/onesignal";

export const AccountPage: FC = () => {
  const user = useSelector((state) => state.user);
  const { instance } = useMsal();
  const name = ObjectUtils.getIn(user?.current, "idTokenClaims.name");
  const email = ObjectUtils.getIn(user?.current, "idTokenClaims.preferred_username");

  const handleLogout = async () => {
    try {
      // Logout OneSignal trước
      await handleOneSignalLogout();
    } catch (error) {
      console.error("OneSignal logout error:", error);
    } finally {
      // Luôn logout MSAL
      instance.logoutRedirect();
    }
  };

  return (
    <div className="AccountPage">
      <Header />
      <div className="pd15">
        <Box title="Thông tin đăng nhập">
          <table className="TableInformation">
            <tbody>
              <tr>
                <td>Name: </td>
                <td>{name}</td>
              </tr>
              <tr>
                <td>Email: </td>
                <td>{email}</td>
              </tr>
            </tbody>
          </table>

          <Button className="mt20 ml10" label="Đăng xuất" buttonType="grey-outline" onClick={handleLogout} />
        </Box>
      </div>
    </div>
  );
};
